module.exports = __webpack_public_path__ + "img/icon-safe5.a9ce5cc7.png";